import { useAuth } from '../../context/AuthContext';

export default function Header() {
  const { user, logout } = useAuth();

  return (
    <header style={styles.header}>

      <div style={styles.logo}>
        Tu<span style={styles.logoSpan}>Rival</span>
      </div>

      <div style={styles.right}>
        {user ? (
          <div style={styles.userArea}>
            <div style={styles.crest}>
              {user.iniciales || 'U'}
            </div>
            <span style={styles.userName}>
              {user.nombre || 'Mi equipo'}
            </span>
            <button style={styles.logoutBtn} onClick={logout}>
              Salir
            </button>
          </div>
        ) : (
          <span style={styles.guestText}>No has iniciado sesión</span>
        )}
      </div>

    </header>
  );
}

const styles = {
  header: {
    background: '#0D1117',
    height: 56,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 24px',
    borderBottom: '1px solid rgba(255,255,255,0.06)',
    flexShrink: 0,
  },
  logo: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 26,
    fontWeight: 800,
    color: 'white',
    letterSpacing: '-0.02em',
  },
  logoSpan: {
    color: '#FF6B1A',
  },
  right: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
  },
  userArea: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
  },
  crest: {
    width: 30,
    height: 30,
    borderRadius: 8,
    background: '#FF6B1A',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 12,
    fontWeight: 800,
    color: 'white',
  },
  userName: {
    fontSize: 13,
    fontWeight: 600,
    color: 'white',
    fontFamily: "'Barlow Condensed', sans-serif",
  },
  logoutBtn: {
    background: 'transparent',
    border: '1px solid rgba(255,255,255,0.15)',
    borderRadius: 7,
    padding: '4px 10px',
    fontSize: 11,
    color: 'rgba(255,255,255,0.5)',
    cursor: 'pointer',
    fontFamily: "'Barlow', sans-serif",
  },
  guestText: {
    fontSize: 12,
    color: 'rgba(255,255,255,0.3)',
    fontFamily: "'Barlow', sans-serif",
  },
};